export interface CriterionCorrection {
  label: string;
  score: number;
  maxScore: number;
  comment: string;
}

export interface ErrorCorrection {
  id: string;
  category: string;
  original: string;
  corrected: string;
  explanation: string;
  severity: "high" | "medium" | "low";
}

export interface WritingCorrection {
  id: string;
  competency: string;
  competencyLabel: string;
  section: string;
  estimatedScore: number;
  maxScore: number;
  nclcEstimate: string;
  cecrlEstimate: string;
  wordCount: number;
  overallComment: string;
  strengths: string[];
  weaknesses: string[];
  criteria: {
    taskAchievement: CriterionCorrection;
    coherence: CriterionCorrection;
    grammar: CriterionCorrection;
    vocabulary: CriterionCorrection;
  };
  errors: ErrorCorrection[];
  improvedVersion: string;
  studySuggestions: string[];
  source?: string;
  createdAt: string;
}

export const mockWritingCorrection: WritingCorrection = {
  id: "mock-ee-correction-001",
  competency: "writing",
  competencyLabel: "Expression Écrite (EE)",
  section: "Section B",
  estimatedScore: 315,
  maxScore: 450,
  nclcEstimate: "NCLC 7",
  cecrlEstimate: "B2",
  wordCount: 245,
  overallComment:
    "O texto apresenta boa organização geral e cumpre a tarefa proposta, mas ainda contém erros recorrentes de preposição, concordância e escolhas lexicais pouco naturais.",
  strengths: [
    "Boa organização das ideias",
    "Uso adequado de conectores simples",
    "Argumentação compreensível",
    "Texto suficientemente desenvolvido"
  ],
  weaknesses: [
    "Erros recorrentes de preposição",
    "Algumas frases longas com estrutura pouco natural",
    "Vocabulário ainda pouco variado",
    "Alguns problemas de concordância"
  ],
  criteria: {
    taskAchievement: {
      label: "Adequação à tarefa",
      score: 7,
      maxScore: 10,
      comment:
        "A resposta trata o tema de forma adequada, mas alguns exemplos poderiam ser mais desenvolvidos."
    },
    coherence: {
      label: "Coerência e organização",
      score: 7,
      maxScore: 10,
      comment:
        "O texto é bem organizado, com progressão lógica das ideias."
    },
    grammar: {
      label: "Gramática",
      score: 6,
      maxScore: 10,
      comment:
        "Há erros gramaticais perceptíveis, mas eles não impedem a compreensão geral."
    },
    vocabulary: {
      label: "Vocabulário",
      score: 6,
      maxScore: 10,
      comment:
        "O vocabulário é funcional, mas poderia ser mais preciso e variado."
    }
  },
  errors: [
    {
      id: "err-001",
      category: "Preposições",
      original: "Je suis allé dans la plage.",
      corrected: "Je suis allé à la plage.",
      explanation:
        "Em francês, usa-se “à la plage” para indicar deslocamento ou localização na praia.",
      severity: "medium"
    },
    {
      id: "err-002",
      category: "Concordância",
      original: "Les personne sont satisfait.",
      corrected: "Les personnes sont satisfaites.",
      explanation:
        "O substantivo e o adjetivo devem concordar em número e gênero.",
      severity: "high"
    },
    {
      id: "err-003",
      category: "Vocabulário",
      original: "C’est une chose très bonne pour la société.",
      corrected: "C’est une mesure très bénéfique pour la société.",
      explanation:
        "A versão corrigida usa um vocabulário mais natural e preciso para um texto argumentativo.",
      severity: "low"
    }
  ],
  improvedVersion:
    "Versão melhorada da redação do usuário aparecerá aqui. Esta versão deve preservar as ideias principais do texto original, mas com melhor organização, vocabulário mais preciso e correções gramaticais.",
  studySuggestions: [
    "Revisar preposições de lugar",
    "Treinar concordância nominal e verbal",
    "Criar flashcards com os erros recorrentes",
    "Praticar conectores argumentativos para Section B"
  ],
  createdAt: new Date().toISOString()
};
